import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import FormControlLabel from '@mui/material/FormControlLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Box from '@mui/material/Box';
import { fetchEtsyData, fetchProgressData, configureStore, resetEtsyState } from './etsySlice';
import Notification from '../../../../../pages/General/Notification';
import ShipmentUpdateFlag from '../../../../General/ShipmentUpdateFlag';

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    height: '100%'
}));

const EtsyIntegration = ({ storeName, storeEtsy, platformName, storeParam, storeId  }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth);
    const etsyconfigdetails = useSelector(state => state.etsy && state.etsy.configure);
    const etsyshowdata = useSelector(state => state.etsy && state.etsy.showdata);
    const [storeUrl, setStoreUrl] = useState("")
    const [values, setValues] = useState({})

    const configurestore = e => {
        e.preventDefault()
        const data = { 
            "store_name": storeUrl,
            "is_update_shipment": values.is_update_shipment,
            "is_update_shipment_on_create": values.is_update_shipment_on_create,
            "is_update_shipment_on_close": values.is_update_shipment_on_close,
            }
        dispatch(configureStore(profile.profile.id,data));
    }

    useEffect(() => {
        if (storeName || storeEtsy) {
            let getStoreId=""
            if(storeName){
                getStoreId=storeName
                setStoreUrl(storeName)
            }else{
                getStoreId=storeEtsy
                setStoreUrl(storeEtsy)
            }
            let apikey = profile.profile.api_token
            const data = { apikey: apikey, store_name: getStoreId }
            dispatch(fetchEtsyData(data));
        }
    }, [storeName || storeEtsy]);

    const updateCallBackValue = (updateValue) => {
        setValues({
            ...values,
            ['is_update_shipment']: updateValue.is_update_shipment,
            ['is_update_shipment_on_create']: updateValue.is_update_shipment_on_create,
            ['is_update_shipment_on_close']: updateValue.is_update_shipment_on_close,
        });
    };

    useEffect(() => {
        if ((storeName || storeEtsy) && etsyshowdata && etsyshowdata.data && Object.keys(etsyshowdata.data).length>0) {
            console.log("success")
            setValues({
                ...values,
                ['is_update_shipment']: etsyshowdata && etsyshowdata.data && etsyshowdata.data.is_update_shipment,
                ['is_update_shipment_on_create']: etsyshowdata && etsyshowdata.data && etsyshowdata.data.is_update_shipment_on_create,
                ['is_update_shipment_on_close']: etsyshowdata && etsyshowdata.data && etsyshowdata.data.is_update_shipment_on_close,
            })
        }
    }, [etsyshowdata]);

    useEffect(() => {  
        dispatch(fetchProgressData())
    }, [dispatch]);

    return (
        <>
         {(etsyconfigdetails && etsyconfigdetails.notification && etsyconfigdetails.notification.messageContent!='') &&
            <Notification
                is_open={etsyconfigdetails.notification.show}
                messageType={etsyconfigdetails.notification.messageType}
                messages={etsyconfigdetails.notification.messageContent}
                handleClose={() => dispatch(resetEtsyState())}
            />}
            {storeUrl=='' &&
                <Grid container spacing={0} justifyContent="center" sx={{ my: 4 }}>
                    <Grid item xs={12} sm={10} md={8} lg={7}>
                        <Card
                            sx={{
                                p: { xs: 3, md: 5 },
                                borderRadius: '16px',
                                border: '1px solid #E2E8F0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01)',
                                backgroundColor: '#FFFFFF'
                            }}
                        >
                            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                                <Item>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 3.5 }}>
                                        
                                        {/* App Brand Identity Section Logo Graphic */}
                                        <Box sx={{ p: 2, backgroundColor: '#FFF7ED', borderRadius: '14px', border: '1px solid #FFEDD5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Box
                                                component="img"
                                                src="/assets/images/integration/ETSY.png"
                                                alt="Etsy"
                                                sx={{ width: 'auto', height: '44px', objectFit: 'contain' }}
                                            />
                                        </Box>

                                        {/* Module Context Headline Header Information */}
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '18px', mb: 0.5, letterSpacing: '-0.3px' }}>
                                                Connect Etsy Marketplace
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#64748B', maxWidth: '380px', mx: 'auto', lineHeight: 1.5 }}>
                                                Install the ShippingChimp application onto your shop account dashboard registry to securely coordinate real-time tracking logs.
                                            </Typography>
                                        </Box>

                                        {/* External Onboarding Authorization Link Action Dispatch Panel */}
                                        <Box className="sc--form--center" sx={{ width: '100%', display: 'flex', justifyContent: 'center', borderTop: '1px solid #F1F5F9', pt: 3 }}>
                                            <Button
                                                variant="contained"
                                                href={`https://www.etsy.com/oauth/connect?response_type=code&redirect_uri=${process.env.REACT_APP_INTEGRATIONS_URL}/etsy/callback&scope=transactions_r%20transactions_w%20email_r%20billing_r%20address_r%20shops_r&client_id=lorux0f6efzr3shvfc1maaii&state=${profile && profile.profile && profile.profile.id}&code_challenge=EFJQPpJgc83fWhV5DC2amk-KGi2SYE4xZt5izK-m4a0&code_challenge_method=S256`}
                                                sx={{
                                                    px: 5,
                                                    py: 1.25,
                                                    borderRadius: '8px',
                                                    fontWeight: 700,
                                                    textTransform: 'none',
                                                    fontSize: '13.5px',
                                                    boxShadow: 'none',
                                                    backgroundColor: '#1976d2',
                                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                                }}
                                            >
                                                Install Etsy App
                                            </Button>
                                        </Box>

                                        {/* Required Platform Trademark Disclaimers Information Node */}
                                        <Box sx={{ mt: 1 }}>
                                            <Typography variant="body2" sx={{ color: '#94A3B8', fontSize: '12px', lineHeight: 1.5, fontWeight: 500, maxWidth: '460px' }}>
                                                The term <b>'Etsy'</b> is a trademark of Etsy, Inc. This application uses the Etsy API but is not endorsed or certified by Etsy, Inc.
                                            </Typography>
                                        </Box>

                                    </Box>
                                </Item>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            }
             
            {storeUrl!=='' &&
                <Grid container spacing={0} justifyContent="center" sx={{ my: 3 }}>
                    <Grid item xs={12} sm={10} md={8}>
                        <Card
                            sx={{
                                p: { xs: 3, md: 5 },
                                borderRadius: '16px',
                                border: '1px solid #E2E8F0',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
                                backgroundColor: '#FFFFFF'
                            }}
                        >
                            <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
                                <Item>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0F172A', mb: 0.5 }}>
                                                Configure Store Environment
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#64748B' }}>
                                                Manage synchronization settings and callback event actions.
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                            <TextField
                                                id="standard-numbe"
                                                label="Etsy Store"
                                                value={storeUrl}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                size="medium"
                                                variant="outlined"
                                                sx={{ 
                                                    width: "100%", 
                                                    maxWidth: '520px',
                                                    '& .MuiOutlinedInput-root': { 
                                                        borderRadius: '8px',
                                                        backgroundColor: '#F8FAFC'
                                                    }
                                                }}
                                            />
                                        </Box>

                                        <Box sx={{ borderTop: '1px solid #F1F5F9', pt: 2 }}>
                                            <ShipmentUpdateFlag
                                                updateFlag={values.is_update_shipment}
                                                onCreateFlag={values.is_update_shipment_on_create}
                                                onCloseFlag={values.is_update_shipment_on_close}
                                                updateCallBack={updateCallBackValue}
                                                message={"Do you want to update shipment information to etsy store?"}
                                            />
                                        </Box>

                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                            <Button
                                                variant="contained"
                                                onClick={configurestore}
                                                sx={{
                                                    px: 5,
                                                    py: 1.25,
                                                    borderRadius: '8px',
                                                    fontWeight: 700,
                                                    textTransform: 'none',
                                                    fontSize: '14px',
                                                    boxShadow: 'none',
                                                    '&:hover': { boxShadow: 'none' }
                                                }}
                                            >
                                                Configure
                                            </Button>
                                        </Box>
                                    </Box>
                                </Item>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            }
        </>
    )
}

export default EtsyIntegration;